import authHelpers from "@/utils/auth-helpers";
import axios from "@axios";
export default {
  namespaced: true,
  state: {
    loading: false,
    user: authHelpers.getUser(),
    notifications: {
      personal: [],
      ngo: [],
      general: [],
      ministry: [],
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      authHelpers.setUser(user);
    },
    setNotifications(state, notifications) {
      state.notifications = notifications;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },
  getters: {
    user(state) {
      return state.user || authHelpers.getUser();
    },
    notifications(state) {
      return state.notifications;
    },
    allNotifications(state) {
      var x = [];
      for (const key in state.notifications) {
        if (Object.hasOwnProperty.call(state.notifications, key)) {
          const element = state.notifications[key];
          if (typeof element === "object" && Array.isArray(element))
            x.push(...element);
        }
      }
      return x;
    },
    loading(state) {
      return state.loading;
    },
  },
  actions: {
    async readNotifications({ dispatch }, isMinistry = false) {
      if (!isMinistry) {
        await axios.post("v2/user-notifications").then((res) => {
          if (res.status >= 200 && res.status <= 400) {
            dispatch("fetchUserNotifications", isMinistry);
          }
        });
      } else {
        await axios.post("v2/ministry/ministry-notifications").then((res) => {
          if (res.status >= 200 && res.status <= 400) {
            dispatch("fetchUserNotifications", isMinistry);
          }
        });
      }
    },
    async fetchUserNotifications({ commit }, isMinistry = false) {
      commit("setLoading", true);
      try {
        if (!isMinistry) {
          const data = await axios
            .get("v2/user-notifications")
            .then((res) => res.data);
          commit("setNotifications", data.data);
        } else {
          const data = await axios
            .get("v2/ministry/ministry-notifications")
            .then((res) => res.data);
          commit("setNotifications", data.data);
        }
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
